module.exports = __webpack_public_path__ + "static/media/164.eed6b2c0.jpg";